module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 2-d7ddffff4b51f6067d025f4f078fc1a7.jpg";